import React from 'react';

import { requiresPropertyOverride } from '../helpers';
import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { Deal } from 'bundles/apex/deals/types';
import type { Project } from 'bundles/apex/deals/connect_to_listing/types';

interface PropertySelectorProps {
  deal: Deal;
  project: Project;
  propertyId?: number;
  onSelect: (propertyId: number) => void;
}

export default function PropertySelector({ deal, project, propertyId, onSelect }: PropertySelectorProps) {
  if (!requiresPropertyOverride(deal, project)) {
    return null;
  }

  const options = [
    { label: deal.researchProperty.name, value: deal.researchProperty.id },
    { label: project.edgeResearchProperty.name, value: project.edgeResearchProperty.id },
  ];

  return (
    <ManagedFormGroup
      inline={false}
      label="This deal and listing cannot be linked to two different properties. Please select one:"
      name="propertyId"
      options={options}
      type="radioGroup"
      value={propertyId}
      onValueChange={onSelect}
    />
  );
}
